import React, { useState, useEffect, useContext, useRef } from "react";
import TrackContext from "../../contexts/track-context";
import TrackItem from "../TrackItem";
import API from "../../services/api";
import AddTrackToProjectPopup from "../Projects/addTrackToProjectPopup";
import Helper from "../../services/helper";
import "./style.css";
import { useHistory, useParams } from "react-router-dom";
import { ReactComponent as CloseModal } from "../../assets/modal-close.svg";
import RippleLoader from "../../assets/loader-2.gif";
import Amplitude from "amplitudejs";
import { Pause } from "@material-ui/icons";
import { PlayArrow } from "@material-ui/icons";
import "./style.css";
import { BouncingLoader } from '../../pure-components/Loader';
import { BouncingLoader2 } from '../../pure-components/Loader';
import Constants from "../../services/constants";
import { toast } from "react-toastify";
import { ErrorToast } from "../../pure-components/CustomToast";
import defaultImage from "../../assets/default_music.png";
import Track from "../Track";
import HarvestService from "../../services/harvestService";

const ActionRecords = (props) => {
  const [showProjectModal, setShowProjectModal] = useState(false);
  const [trackToBeAddedToProject, setTrackToBeAddedToProject] = useState("");
  const [expandedTrackId, setExpandedTrackId] = useState("");
  const [loading, setLoading] = useState(true);
  const [marginTop, setMarginTop] = useState("20px");
  const [isMobile, setIsMobile] = useState(false);
  // const {albumId}=useParams();
  
  const [downloadingTracks, setDownloadingTracks] = useState([]);
  const [favingTracks, setFavingTracks] = useState([]);

  const [pathName, setPathName] = useState(window.location.pathname);
  
  const getPageId = ()=>{
    const path = window.location.pathname;
    switch (true) {
      case (path.includes("/favourites") || path.includes("admin/favourites")):
      return "favourites";

      case (path.includes("/history") || path.includes("admin/history")):
      return "history";
      
      case (path.includes("/")):
      return "music";

      
      default:
        break;
    }
  }

  const [filterTrackIds, setFilterTrackIds] = useState({})
  const [pageId, setPageId] = useState(getPageId());
  const [listData, setListData] = useState([]);
  const [searchedListData, setSearchedListData] = useState([]);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    (() => {
      setPathName(window.location.pathname);
      setPageId(getPageId());
    })();
  }, [window.location.pathname]);
  
  useEffect(() => {
   (async() => {
      if (pageId === "favourites") {
        const favorites = JSON.parse(localStorage.getItem("favs") || "{}");
        if(Object.keys(favorites)?.length > 0){
          setFilterTrackIds(Object.keys(favorites));
        }else{
          setLoading(false);
        }
      }
      if (pageId === "history") {
        const history = JSON.parse(localStorage.getItem("history") || "{}");
        if(Object.keys(history)?.length > 0){
          const tempIds = [];
          Object.keys(history).forEach((elem) => {
            if(elem?.length > 0 && elem?.includes(":=>")){
              tempIds.push(elem.split(":=>")[0] || "")
            }else if(!elem?.includes(":=>")){
              tempIds.push(elem);
            }
          })
          setFilterTrackIds(tempIds);
        }else{
          setLoading(false);
        }
      }
      if (pageId === "music") {
        if(props.trackIds?.length > 0)
          setFilterTrackIds(props.trackIds);
        else
          setLoading(false);
      }
    })();
  },[pageId]);

  
  useEffect(() =>{

    // set the margin of playbutton

    const updateMargin = () => {
      if (window.innerWidth < 768) {
        setMarginTop("-10px"); // Mobile view
      } else if (window.innerWidth < 1024) {
        setMarginTop("-50px"); // Tablet view
      } else {
        setMarginTop("-50px"); // Desktop view
      }
    };

    updateMargin(); // Set initial value
    window.addEventListener("resize", updateMargin);

    return () => {
      window.removeEventListener("resize", updateMargin);
    }
  }, [pageId]);

  useEffect(() => {
    // console.log("trackIds : ", filterTrackIds);
    if(filterTrackIds?.length > 0)
      loadPageData(filterTrackIds);
  }, [filterTrackIds])

  const loadPageData = async(trackIds) => {
    setLoading(true);
    const filter = {
      "ReturnAlternateVersions":"false",
      "ReturnAttributes":"false",
      "ReturnCategories":"false",
      "ReturnCategoryFacet":"false",
      "ReturnCodes":"false",
      "ReturnComposers":"true",
      "ReturnRelatedTracks":"false",
      "ReturnRightHolders":"false",
      "GetMainVersionFromAlternate":"false",
      "CuesheetOnlyCodesAndAttribute":"false",
      "ReturnInactiveTracks":"false",
      "ReturnRegionOnlyTracks":"false",
      "Offset":"0",
      "Limit":"1000",
      "track":trackIds?.slice(0, 1000)
    }
    const reqObj = {
      refUrl : `/gettracks/{memberToken}`, 
      method : 'post',
      headers : {
          "Accept" : "application/json",
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': '0',
      },
      data : JSON.stringify(filter)
    };
    await HarvestService.loadHarvestData(reqObj).then((resp) => {
      // console.log("track data resp : ", resp);
     
      setListData(resp?.Tracks);
      setSearchedListData(resp?.Tracks)
    }).catch((err) => {
      console.log("Track data Loading Error : ", err);
      toast(({ closeToast }) => <ErrorToast message={`${pageId} page data loading failed.`} />);
    }).finally(() => {
      setLoading(false);
    })
  }

  const handleSearch = async(e) => {
    
    if(e.key === 'Enter' && !loading){
      if(searchText?.length > 0){
        const filteredList = listData?.filter((elem) => elem.DisplayTitle?.toLowerCase().includes(searchText.toLowerCase()) || elem.Name?.toLowerCase().includes(searchText.toLowerCase()) || elem.Comment?.toLowerCase().includes(searchText.toLowerCase()))
        setSearchedListData(filteredList)
      }else{
        setSearchedListData(listData);
      }
    }
  };

  const displayProjectModal = (trackId) => {
    setTrackToBeAddedToProject(trackId);
    setShowProjectModal(true);
  };

  const closeProjectModal = () => {
    setShowProjectModal(false);
  };
    
    useEffect(() => {
      const checkScreenSize = () => {
        setIsMobile(window.innerWidth <= 480);
      };
  
      checkScreenSize(); // Initial check
      window.addEventListener('resize', checkScreenSize);
  
      return () => window.removeEventListener('resize', checkScreenSize);
    }, []);
  
    const ResponsiveLoading = ({ isMobile }) => (
    <>
      <div className="row" />
      {isMobile ? <BouncingLoader2 /> : <BouncingLoader />}
    </>
  );

  return (
    <>
      {loading && (
        <div className="w-full flex justify-center items-center"
        style={{minHeight: "80vh", maxHeight : "80vh", overflowY:"scroll"}}
        >
            {/* <ResponsiveLoading isMobile={isMobile} /> */}
          <BouncingLoader />
        </div>
      )}
      {(!loading && (pageId === "history" || pageId === "favourites")) &&
        <div className="lg:w-full" style={{minHeight: "80vh", maxHeight : "80vh", overflowY:"scroll"}}>
          <div className="text-sm w-full flex flex-col sm:flex-row items-center mb-4 Lg:mx-10 sm:mb-0">
            <h1 className='w-full sm:w-1/3 text-center sm:text-left pl-2 text-xl font-bold text-black mb-3 sm:mb-0 '>
              {pageId === "favourites" && 'My Favourites'}
              {pageId === "history" && 'Play History'}
            </h1>
            <div className="w-full sm:w-2/3 flex justify-center sm:justify-end pr-10">
              <input
                onChange={event => { setSearchText(event.target.value) }}
                onKeyDown={handleSearch}
                type="text"
                placeholder={pageId === "favourites" ? 'Search favourites' : 'Search play history'}
                className="w-full sm:w-2/3 md:w-1/2 input-search h-10"
              />
            </div>
          </div>
          <div className=" sm:flex sm:flex-col sm:w-full py-2" style={{minHeight: "80vh", maxHeight : "80vh", overflowY:"scroll"}}>

            {!loading && searchedListData.length === 0 && (
              <div className="text-xl text-center text-red-500">
                No Data Found
              </div>
            )}
            
            <div className="w-full  sm:flex sm:flex-wrap  justify-center">
            {/* {(!loading && (!searchedListData?.length === 0)) && (
              <div className="text-xl text-center text-red-500 mt-4">
                No Data Found
              </div>
            )} */}
            {
              !loading && searchedListData?.length > 0 && 
              (<div className="text-xl w-full text-red-500 mt-4">
                {searchedListData?.map((track, index, arr) => {
                return (
                  
                    <Track
                      // tags={track.tags}
                      image={Helper.getArtworkURL(track.AlbumID)}
                      key={track.ID}
                      albumId={track.AlbumID}
                      title={track.DisplayTitle || track.Name}
                      duration={track.LengthSeconds}
                      bpm={track.Bpm}
                      versions={track.AlternateCount}
                      producer={track.Publisher}
                      artistName={
                        Helper.getComposerNames(track.Composers)
                      }
                      album={track.AlbumName}
                      trackId={track.ID}
                      waveform={Helper.getWaveformURL(track.ID)}
                      // setTrackUrl={props.setTrackUrl}
                      // setFetchingTrack={trackContext.setFetchingTrack}
                      // changeCurrentTrackImage={props.changeCurrentTrackImage}
                      displayProjectModal={displayProjectModal}
                      // handleCurrentTrackDetail={props.handleCurrentTrackDetail}
                      // similarity={track?.similarity}
                      description={track?.Comment}
                      expandedTrackId={expandedTrackId}
                      setExpandedTrackId={setExpandedTrackId}
                      pageId={pageId}
                      artists={
                        Helper.getComposers(track.Composers)
                      }

                      downloadingTracks = {downloadingTracks}
                      setDownloadingTracks = {setDownloadingTracks}
                      favingTracks = {favingTracks}
                      setFavingTracks = {setFavingTracks}
                      commandOnChange = {setFilterTrackIds}
                      
                      lyrics = {track.Lyrics || "" }
                    />
                  
                  )
                })}
              </div>)
            }
            </div>
            
          </div>
        </div>
      }
      {!loading && pageId === "music" && 
        <div className="w-full  sm:flex sm:flex-wrap  justify-center" style={{minHeight: "80vh", maxHeight : "80vh", overflowY:"scroll"}}>
          {(!loading && (!searchedListData?.length === 0)) && (
            <div className="text-xl text-center text-red-500 mt-4">
              No Data Found
            </div>
          )}
          {
            !loading && searchedListData?.length > 0 && 
            (<div className="text-xl w-full text-red-500 mt-4">
              {searchedListData?.map((track, index, arr) => {
              return (
                
                  <Track
                    // tags={track.tags}
                    image={Helper.getArtworkURL(track.AlbumID)}
                    key={track.ID}
                    albumId={track.AlbumID}
                    title={track.DisplayTitle || track.Name}
                    duration={track.LengthSeconds}
                    bpm={track.Bpm}
                    versions={track.AlternateCount}
                    producer={track.Publisher}
                    artistName={
                      Helper.getComposerNames(track.Composers)
                    }
                    album={track.AlbumName}
                    trackId={track.ID}
                    waveform={Helper.getWaveformURL(track.ID)}
                    // setTrackUrl={props.setTrackUrl}
                    // setFetchingTrack={trackContext.setFetchingTrack}
                    // changeCurrentTrackImage={props.changeCurrentTrackImage}
                    displayProjectModal={displayProjectModal}
                    // handleCurrentTrackDetail={props.handleCurrentTrackDetail}
                    // similarity={track?.similarity}
                    description={track?.Comment}
                    expandedTrackId={expandedTrackId}
                    setExpandedTrackId={setExpandedTrackId}
                    pageId={pageId}
                    artists={
                      Helper.getComposers(track.Composers)
                    }

                    downloadingTracks = {downloadingTracks}
                    setDownloadingTracks = {setDownloadingTracks}
                    favingTracks = {favingTracks}
                    setFavingTracks = {setFavingTracks}

                    lyrics = {track.Lyrics || ""}
                  />
                
                )
              })}
            </div>)
          }
        </div>
      }

      {showProjectModal && (
        <AddTrackToProjectPopup
          trackToBeAddedToProject={trackToBeAddedToProject}
          closeProjectModal={closeProjectModal}
        />
      )}
    </>
  );
};

export default ActionRecords;